document.addEventListener('change', function(e) {

  const select = e.target;

  if (!select.classList.contains('collection-variant-select')) return;


  const wrapper = select.closest('.card__information');


  if (!wrapper) {
    return;
  }

  const hiddenInput =
    wrapper.querySelector('.selected-variant-id');

  if (hiddenInput) {
    hiddenInput.value = select.value;
  }

  const price =
    wrapper.querySelector('.collection-card-price');

  if (price) {
    price.textContent =
      select.options[select.selectedIndex].dataset.price;
  }

});